import angular from "angular";
import { angularServicesNames } from "@topline/services/angularServicesNames";

class BudgetVersionConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider
            .state("budgetVersion", {
                abstract: true,
                resolve: {
                    translateReady: [
                        angularServicesNames.$translate,
                        ($translate: ng.translate.ITranslateService) => {
                            return $translate.onReady();
                        }
                    ]
                }
            })
            .state("budgetVersion.dashboard", {
                url: "^/budget-version/dashboard",
                template: require("./budgetVersionDashboard.html"),
                controller: "budgetVersionDashboardCtrl",
                controllerAs: "$ctrl"
            });
    }
}

angular.module("topline.modules").config(BudgetVersionConfig);
